module.exports = __webpack_public_path__ + "img/price-click-1.7e8c54f7.jpg";